import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';

import { GenericIntegrationService } from '../../../shared/service/generic-integration.service';
import { GenericIntegrationModel } from '../../../shared/model/generic-integration.model';
import { HeaderItemTypeTranslation } from './../../../shared/enum/header-item-type';
import { DynamicListService } from '../../../shared/service/dynamic-list.service';
import { DynamicListModel } from '../../../shared/model/dynamic-list.model';
import { HeaderItemModel } from '../../../shared/model/header-item.model';
import { ListService } from '../../../shared/service/list.service';
import { ListModel } from '../../../shared/model/list.model';

@Component({
	selector: 'app-header-item-modal',
	templateUrl: './header-item-modal.component.html',
	styles: [
		`
			.alinhamento {
				margin: 10px 0px 0px !important;
				padding: 8px !important;
			}
		`
	]
})
export class HeaderItemModalComponent implements OnInit {
	@Output() save = new EventEmitter<HeaderItemModel>();

	headerItem: HeaderItemModel = new HeaderItemModel();
	headerItems: HeaderItemModel[] = [];

	headerItemTypes: SelectItem[] = [];

	genericIntegrations: GenericIntegrationModel[] = [];
	genericIntegration = new GenericIntegrationModel();
	dynamicLists: DynamicListModel[] = [];
	lists: ListModel[] = [];

	genericIntegrationOptions: SelectItem[] = [];
	dynamicListOptions: SelectItem[] = [];
	listOptions: SelectItem[] = [];

	orderLimit: number;
	display: boolean;
	// isNew: boolean

	// Auxiliars

  selectedOrdenation = '';
  selectedMethod = '';
	chooseListWord = '';

  pagination = { init: 0, end: 1e8 };

  ascDesc = [
    { value: 'asc', label: "Ascendente" },
    { value: 'desc', label: "Decrescente" },
  ];

  ordenation = [
    { value: 'id', label: "Data de Criação" },
    { value: 'name', label: "Ordem Alfabetica" },
  ];

	constructor(
		private integrationService: GenericIntegrationService,
		private translateService: TranslateService,
		private dynListService: DynamicListService,
		private listService: ListService,
	) {}

	ngOnInit() {
		setTimeout(() => {
			this.buildHeaderItemTypes();
		}, 1000);
	}

	getListName(headerItem: HeaderItemModel) {
		const { list_id, dyn_list_id } = headerItem;

		if (headerItem) {
			if (list_id) {
				const list = this.listOptions.find(({ value }) => value == list_id);
				if (list) return list.label;
			}

			if (dyn_list_id) {
				const list = this.dynamicListOptions.find(({ value }) => value == dyn_list_id);
				if (list) return list.label;
			}
		}

		return this.chooseListWord;
	}

	onOpenModal() {
		this.buildLists();
		this.buildDynamicLists();
		this.buildGenericIntegrationLists();

		this.getIntegrationData({ value: this.headerItem.generic_integration_id || 0 });
	}

	saveHeaderItem() {
		if (
			this.genericIntegration &&
			this.genericIntegration.type_id &&
			(
				this.genericIntegration.id ||
				this.genericIntegration.id == 0
			)
		) {
      this.integrationService.save(this.genericIntegration)
			.pipe(take(1)).subscribe((data: any) => {
				try {
					this.genericIntegration = data as GenericIntegrationModel;
				} catch (e) {
					console.error(e);
				}

				// when creating a new integration, auto update the header
				if (data && !data.length && data.id && !isNaN(data.id)) {
					this.headerItem.generic_integration_id = data.id;
				}

				this.save.emit(this.headerItem);
			});
		} else {
			this.save.emit(this.headerItem);
		}

		this.display = false;
		// this.isNew = false
	}

	getIntegrationData({ value: integrationId }) {
		if (integrationId) {
      this.integrationService.findByPk(integrationId).pipe(take(1))
      .subscribe((data: HeaderItemModel | any) => {
				this.headerItem.generic_integration_id = integrationId;
				this.genericIntegration = data;
			});
		} else {
			this.genericIntegration = {
				external_token: '',
				customer_name: '',
				external_api: '',
				customer_id: '',
				type_id: '',
				id: 0,
			} as any;
		}
	}

	existDuplicateItem() {
		if (this.headerItems)	return this.headerItems.find(item => 
			item.description == this.headerItem.description && item.id != this.headerItem.id) ? true : false;
		else return false;
	}

	validate() {
		if(this.existDuplicateItem()) return false;

		return HeaderItemModel.validate(this.headerItem);
	}

	isListType = () => this.headerItem.header_item_type == 5;
	isDynamicListType = () => this.headerItem.header_item_type == 7;

	buildHeaderItemTypes() {
		let types: number[] = [];

		for (let type in HeaderItemTypeTranslation) {
			if(!isNaN(parseInt(type))) {
				types.push(parseInt(type))
			}
		}		

		this.translateService.get('translate_version').subscribe(_ => {
			types.forEach(value => {
				const realName = HeaderItemTypeTranslation[value];
				const label = this.translate(realName);

				this.headerItemTypes.push({
					label, value, 
				});
			});
		});

		this.chooseListWord = this.translate('choose_list');
	}

	buildLists() {
		this.listOptions = [];

		this.listService.getPaginated(0, 1000).subscribe(result => {
			const lists = result['rows'] as ListModel[];
			this.lists = lists;

			lists.forEach(({ id: value, name: label }) => {
				this.listOptions.push({ value, label });
			})
		});
	}

	buildDynamicLists() {
		this.dynamicListOptions = [];

		this.dynListService.getPaginated(this.pagination).subscribe(result => {
			const dynamicLists = result['rows'] as DynamicListModel[];
			this.dynamicLists = dynamicLists;

			dynamicLists.forEach(({id: value, name: label }) => {
				this.dynamicListOptions.push({ value, label });
			})
		});
	}

	buildGenericIntegrationLists() {
		this.genericIntegrationOptions = [
			{ value: null, label: '' },
		];

		this.integrationService.getPaginated(0, 1000).subscribe(result => {
			const lists = result['rows'] as any[];
			this.genericIntegrations = lists;

			lists.forEach(({ id: value, customer_name: label }) => {
				this.genericIntegrationOptions.push({ value, label });
			})
		});
	}

	// Auxiliars

	translate = (key: string) => this.translateService.instant(key || "invalid");

	order() {
			this.listOptions = [];
			this.dynamicListOptions = [];

			const sortedLists = _.orderBy(this.lists, this.selectedOrdenation, this.selectedMethod);
			const sortedDynLists = _.orderBy(this.dynamicLists, this.selectedOrdenation, this.selectedMethod);

			sortedLists.forEach(({ id: value, name: label }) => {
				this.listOptions.push({ value, label });
			})

			sortedDynLists.forEach(({ id: value, name: label }) => {
				this.dynamicListOptions.push({ value, label });
			})
	}

	// updateOrder(e) {
	// 	this.save.emit(e);
	// }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/header-item/header-item-modal/header-item-modal.component.ts